var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box loading"},[_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"loading-row"},[_c('div',{staticClass:"dot-elastic"})])])])
}]

export { render, staticRenderFns }